/*
 * @Author       : 程哲林
 * @Date         : 2021-11-26 16:43:01
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-12 11:27:49
 * @FilePath     : /marketing-introduce-ssr/components/Activity/TeamComp/index.tsx
 * @Description  : 未添加文件描述
 */

import { Toast } from 'antd-mobile';
import cx from 'classnames';
// import { useRouter } from 'next/router'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import qs from 'querystring';
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { envPath, SERVICE_URL } from '@/common/const';
import { DEFAULT_HEAD_PIC } from '@/common/const';
import { PAGE_LOADING_STOP } from '@/common/enums';
import { ActionSheet } from '@/components/Activity/ActionSheet';
import { TipsPopup } from '@/components/Activity/TipsPopup';
import { groupBooking, queryCollageData } from '@/services/activity';
import {
  computePrice,
  durationTime,
  isInViewPort,
  isIOS,
  isJoJoAllBrowser,
  jumpPay,
  qsParse,
  reportError
} from '@/utils';
import bus from '@/utils/bus';
// import { login } from '@/utils/request';
import { sensClickInitiative } from '@/utils/sensors';

import { Button } from '../Button';
import { itemSwitch } from '../Swiper';
// import { ActionSheet, ActionSheetComp, ConfirmOrder } from '../index'
import styles from './index.module.scss';
import { CommodityType, CreateOrderType } from './type';

dayjs.extend(duration);

export interface TourDetailType {
  countdown: string;
  groupAvatarUrl: any[];
  groupBookId: string;
  lastCount: string;
  nickName: string;
  url: string;
  userId: string;
  status?: string;
  activityScopeIncludedCurrentUser: boolean;
  collageLimitIncludedCurrentUser: boolean;
}

interface TeamPanelProps {
  fastTeam: null | TourDetailType;
  startDate: number;
  endDate: number;
  teamStatus: number;
  minGroupPrice: number;
  maxOriginalPrice: number;
  activityId: string;
  activityCode: string;
  productId?: string | null;
  isCanJoinGroup: boolean;
  componentId: string;
  isNoGoods: boolean;
  invite?: any;
}
interface TeamListProps {
  backImage: string;
  tourDetail: TourDetailType[];
  activityId: string;
  activityCode: string;
  isCanJoinGroup: boolean;
  componentId: string;
}

// 开团的状态
const openStatus = [1, 2, 4, 7];
// 参团状态
const participateStatus = [5, 6];
const btnText = [
  '商品已抢光',
  '立即开团',
  '立即开团',
  '',
  '立即开团',
  '立即参团',
  '立即参团',
  '立即开团'
];

const msgText = [
  '抱歉来晚啦，商品已抢光',
  '抱歉来晚啦，该团已满员',
  '抱歉来晚啦，该团已结束拼团',
  'collageLimitText',
  'collageLimitText',
  'time',
  'time',
  '抱歉来晚啦，该团已结束拼团'
];

function getActStatus({
  riskUser,
  activityScopeIncludedCurrentUser,
  collageLimitIncludedCurrentUser,
  countdown: cd,
  lastCount
}: any) {
  const countdownNum = Number(cd);

  if (riskUser === 'RISK_USER') {
    return 0;
  } else if (lastCount === 0 && countdownNum === 0) {
    return 7;
  } else if (
    lastCount === 0 &&
    countdownNum !== 0 &&
    activityScopeIncludedCurrentUser &&
    !collageLimitIncludedCurrentUser
  ) {
    return 1;
  } else if (
    lastCount !== 0 &&
    countdownNum === 0 &&
    activityScopeIncludedCurrentUser &&
    !collageLimitIncludedCurrentUser
  ) {
    return 2;
  } else if (!activityScopeIncludedCurrentUser && !collageLimitIncludedCurrentUser) {
    return 3;
  } else if (activityScopeIncludedCurrentUser && !collageLimitIncludedCurrentUser) {
    return 4;
  } else if (!activityScopeIncludedCurrentUser && collageLimitIncludedCurrentUser) {
    return 5;
  } else if (activityScopeIncludedCurrentUser && collageLimitIncludedCurrentUser) {
    return 6;
  } else {
    return 0;
  }
}

export const useScroll = (id: string): [boolean] => {
  const [isShow, setShow] = useState(false);

  useEffect(() => {
    const $ele = document.getElementById(id) as HTMLElement;
    let timerList: any = null;
    function onScroll() {
      try {
        clearTimeout(timerList);
        timerList = setTimeout(() => {
          const show = isInViewPort($ele);
          setShow(!show);
        }, 200);
      } catch (e) {
        console.error(e);
      }
    }

    if ($ele) {
      document.addEventListener('scroll', onScroll);
      onScroll();
    }
    return () => {
      clearTimeout(timerList);
      document.removeEventListener('scroll', onScroll);
    };
  }, [id]);

  return [isShow];
};

function countdown(step = 1000) {
  try {
    const items = document.querySelectorAll('.j-timer');

    if (items) {
      for (let index = 0; index < items.length; index += 1) {
        const item = items[index] as HTMLDivElement;
        const time = item.getAttribute('data-timer') as string;
        const newTime = Number(time) - step;

        if (newTime >= step) {
          item.innerText = `剩余 ${durationTime(newTime)}`;
        } else {
          item.innerText = '已结束';
        }

        item.setAttribute('data-timer', newTime.toString());
      }
    }
  } catch (e) {
    reportError(e);
  }
}

export interface ToOrderType {
  activityCode?: string;
  activityId?: any;
  groupBookingId?: string;
  inviteCode?: string;
  vPhone?: string;
  itemIndex?: number;
}

let checkOrderTimer: any = null;
export function checkOrder(item: any = {}, isAuto = false) {
  clearTimeout(checkOrderTimer);
  const query = qsParse();
  const { channel, channelNo, inviteCode } = query;
  const { groupBookingId, activityId } = item;
  checkOrderTimer = setTimeout(async () => {
    if (!isAuto) {
      Toast.loading('正在创建订单...');
    }

    try {
      const { code, message, data } = await queryCollageData<CommodityType>(
        {
          activityCode: item.activityCode
        },
        {
          scene: 'GROUP',
          groupBookingId
        }
      );
      Toast.hide();

      if (code !== 'SUCCESS') {
        bus.emit(PAGE_LOADING_STOP);
        Toast.fail(message || '数据请求错误');
        return;
      }

      const { redirectMyGroupPage, preOrderId, riskUser, bookingSkus } = data;

      if (riskUser === 'RISK_USER') {
        bus.emit(PAGE_LOADING_STOP);
        Toast.info('商品已抢光');
        return;
      }

      // 有订单号或在已拼团过
      if (preOrderId || redirectMyGroupPage) {
        bus.emit(PAGE_LOADING_STOP);
        ActionSheet.showInstance(
          <TipsPopup
            visible
            title=''
            onClose={() => {
              ActionSheet.removeInstance('ui-popup');
            }}
            btnText='我知道啦'
            onConfirm={() => {
              window.location.href = `/activity/team/mine?${qs.stringify({ channel, channelNo })}`;
            }}>
            <div className='ui-center'>您已参加拼团活动，点击下方按钮查看拼团进度哦</div>
          </TipsPopup>,
          'ui-popup'
        );
      } else {
        // 判断是否可下0元单
        // 单sku、0元、无需发货
        if (bookingSkus?.length === 1) {
          const [sku] = bookingSkus;
          const { groupPrice, needShip, skuId, productId } = sku || {};
          if (['0', 0].includes(groupPrice) && !needShip) {
            if (!isAuto) {
              Toast.loading('正在创建订单...');
            }

            const orderRes = await groupBooking<CreateOrderType>({
              activityId,
              groupBookingId,
              skuId,
              productId,
              inviteCode
            });
            bus.emit(PAGE_LOADING_STOP);
            const { code: orderCode, data: orderData, message: orderMessage } = orderRes || {};
            if (orderCode !== 'SUCCESS') {
              Toast.fail(orderMessage);
              return;
            }
            if (!data) {
              Toast.fail('系统开小差啦！');
              return;
            }
            const {
              groupBookingOrderId,
              preOrderId: orderPreId,
              isSuccess,
              failType,
              message: dataMessage
            } = orderData;
            if (!isSuccess) {
              Toast.fail(dataMessage, 2, () => {
                if (failType === 'GROUP_FULL') {
                  Toast.fail('团已满');
                  window.location.reload();
                } else if (failType !== 'ACTIVITY_END') {
                  window.location.href = `/activity/team/mine?${qs.stringify({
                    channel,
                    channelNo
                  })}`;
                }
              });
              return;
            }
            if (groupBookingOrderId && !orderPreId) {
              setTimeout(() => {
                Toast.hide();
                window.location.href = `/activity/team?${qs.stringify({
                  channel,
                  channelNo,
                  groupOrderId: groupBookingOrderId
                })}`;
              }, 500);

              return;
            }
          }
        }
        jumpPay(item);
      }
    } catch (e) {
      reportError(e);
    }
  }, 150);
}

let timer: any = null;

const TeamList = React.memo(
  ({
    backImage = '',
    tourDetail = [],
    activityId,
    activityCode,
    isCanJoinGroup,
    componentId
  }: TeamListProps): JSX.Element | null => {
    const elRef = useRef<HTMLDivElement>(null);
    const maxLen = tourDetail.length;
    useEffect(() => {
      if (maxLen > 2) {
        itemSwitch(
          elRef.current,
          {
            speed: 0.4
          },
          () => {
            countdown(3000);
          }
        );
      } else {
        timer = setInterval(() => {
          countdown();
        }, 1000);
      }

      return () => {
        clearInterval(timer);
      };
    }, [maxLen]);

    useEffect(() => {
      const { scene, groupBookingId } = __store?.sceneParams || {};
      if (scene === 'GROUP' && groupBookingId) {
        __store.sceneParams = null;
        // 用户登录前点击的是参团并且该团还存在
        const existTeam = tourDetail?.find((tour) => tour.groupBookId === groupBookingId);
        if (existTeam) {
          const { collageLimitIncludedCurrentUser } = existTeam;
          if (collageLimitIncludedCurrentUser && isCanJoinGroup) {
            checkOrder(
              {
                activityId,
                activityCode,
                groupBookingId
              },
              true
            );
            return;
          }
        }
        bus.emit(PAGE_LOADING_STOP);
      }
    }, []);

    if (maxLen <= 0) {
      return null;
    }

    return (
      <div
        style={{
          backgroundImage: `url(${backImage})`
        }}
        className={styles['cp-team-list']}
        id='cp-team-list'>
        <div className={styles.tit}>他们正在拼团，可直接参与</div>
        <div className={styles.content}>
          <div id='j-team-list' ref={elRef} className={styles.list}>
            {tourDetail.map(
              ({
                nickName,
                url,
                lastCount,
                countdown: cd,
                groupBookId,
                collageLimitIncludedCurrentUser
              }) => {
                if (!collageLimitIncludedCurrentUser) {
                  return null;
                }

                return (
                  <div className={styles.item} key={nickName}>
                    <div className={styles.img}>
                      <img src={url || DEFAULT_HEAD_PIC} alt='' />
                    </div>
                    <div className={cx(styles.name, 'fn-cut')}>{nickName}</div>
                    <div className={styles.panel}>
                      <div className={styles.info}>
                        <div className={styles.t}>
                          还差<span>{lastCount}</span>人成团
                        </div>
                        <div data-timer={cd} className={cx(styles.b, 'j-timer')}>
                          剩余 {durationTime(Number(cd))}
                        </div>
                      </div>
                      <button
                        type='button'
                        sensors-disable='true'
                        onClick={() => {
                          if (!isCanJoinGroup) {
                            Toast.info('您没有参团权限');
                            return;
                          }

                          sensClickInitiative({
                            $element_name: '运营活动活动页_组件点击',
                            $element_id: componentId,
                            $element_type: '拼团',
                            $element_content: '10'
                          });

                          checkOrder({
                            activityId,
                            activityCode,
                            groupBookingId: groupBookId
                          });
                        }}
                        className={cx('ui-icon', 'ui-icon__img15', styles.btn)}
                      />
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    );
  }
);

let timer2: any = 0;
const TeamPanel = React.memo(
  ({
    fastTeam,
    teamStatus,
    minGroupPrice,
    startDate,
    maxOriginalPrice,
    activityId,
    activityCode,
    productId,
    componentId,
    isNoGoods
  }: // endDate,
  Omit<TeamPanelProps, 'endDate' | 'isCanJoinGroup'>): JSX.Element => {
    const [time, setTime] = useState<number>(Number(fastTeam?.countdown) || 0);
    const [isShow] = useScroll('j-team-list');
    const timeRef = useRef(0);
    timeRef.current = time;

    useEffect(() => {
      clearInterval(timer2);

      // 拼团倒计时
      if (fastTeam && teamStatus === 1) {
        timer2 = setInterval(() => {
          const t = timeRef.current - 1000;
          setTime(t);
        }, 1000);
      }

      // 开团倒计时
      if (teamStatus === 0) {
        timer2 = setInterval(() => {
          const t = startDate - Date.now();
          setTime(t);
        }, 1000);
      }

      return () => {
        clearInterval(timer2);
      };
    }, [fastTeam, startDate, teamStatus]);

    useEffect(() => {
      const { scene, groupBookingId } = __store?.sceneParams || {};
      // 用户登录前点击的是开团,不考虑快速参团
      if (scene === 'GROUP') {
        if (!groupBookingId) {
          __store.sceneParams = null;
          checkOrder(
            {
              activityId,
              activityCode
            },
            true
          );
        } else {
          const teamList = document.getElementById('cp-team-list');
          if (!teamList) {
            // 不满足参团条件时，在这里处理
            __store.sceneParams = null;
            bus.emit(PAGE_LOADING_STOP);
          }
        }
      }
    }, []);

    const btnDisabled = teamStatus !== 1 || isNoGoods;

    const hasMinGroupPrice = typeof minGroupPrice === 'number' || /\d/g.test(minGroupPrice);

    const getJoinGroupBtnText = () => {
      if (teamStatus === 0) {
        return (
          <>
            <strong>¥{minGroupPrice / 100}即将开团</strong>
            <span>{durationTime(time, 'format').format('DD天 HH:mm:ss')}</span>
          </>
        );
      }
      if (teamStatus === 1) {
        if (isNoGoods) {
          return <span>商品已抢光</span>;
        }
        return (
          <>
            <strong>¥{minGroupPrice / 100}</strong>
            <span>发起团购</span>
          </>
        );
      }
      return <span>活动已结束</span>;
    };

    return (
      <div className={styles['cp-team-panel']}>
        {fastTeam &&
        // 是否参团
        fastTeam?.collageLimitIncludedCurrentUser &&
        // 是否开始
        teamStatus === 1 &&
        // 滚动显示
        isShow &&
        // 是否风险用户
        !isNoGoods ? (
          <div className={styles.item}>
            <div className={styles.img}>
              <img src={fastTeam?.url || DEFAULT_HEAD_PIC} alt='' />
            </div>
            <div className={cx(styles.name, 'fn-cut')}>{fastTeam?.nickName}</div>
            <div className={styles.panel}>
              <div className={styles.info}>
                <div className={styles.t}>
                  还差<span>{fastTeam?.lastCount}</span>人成团
                </div>
                <div className={styles.b}>剩余 {durationTime(time)}</div>
              </div>
              <button
                type='button'
                sensors-disable='true'
                onClick={() => {
                  if (!fastTeam.collageLimitIncludedCurrentUser) {
                    Toast.info('您没有参团权限');
                    return;
                  }

                  sensClickInitiative({
                    $element_name: '运营活动活动页_组件点击',
                    $element_id: componentId,
                    $element_type: '拼团',
                    $element_content: '10'
                  });

                  // console.log(fastTeam)
                  checkOrder({
                    activityId,
                    activityCode,
                    groupBookingId: fastTeam.groupBookId
                  });
                }}
                className={cx('ui-icon', 'ui-icon__img15', styles.btn)}
              />
            </div>
          </div>
        ) : null}
        <div className={styles.buy}>
          <a href={SERVICE_URL} className={styles.service}>
            <i className='ui-icon ui-icon__img16' />
            <span>客服</span>
          </a>
          {isIOS() && isJoJoAllBrowser() ? (
            <div className={styles.iapText}>原价¥{computePrice(maxOriginalPrice)}</div>
          ) : (
            <Button
              onClick={() => {
                sensClickInitiative({
                  $element_name: '运营活动活动页_组件点击',
                  $element_id: componentId,
                  $element_type: '拼团',
                  $element_content: '1'
                });

                const { channel = '', channelNo } = qsParse();
                const url = `https://mall${envPath()}.tinman.cn/item/detail?productId=${productId}&activityCode=${activityCode}&toPurchased=true&channel=${channel}&channelNo=${channelNo}`;
                window.location.href = url;
              }}
              className={cx(styles.btn, styles.solo)}>
              {maxOriginalPrice ? <strong>¥{computePrice(maxOriginalPrice)}</strong> : null}
              <span>单独购买</span>
            </Button>
          )}

          {hasMinGroupPrice ? (
            <Button
              disabled={btnDisabled}
              onClick={() => {
                sensClickInitiative({
                  $element_name: '运营活动活动页_组件点击',
                  $element_id: componentId,
                  $element_type: '拼团',
                  $element_content: '2'
                });

                checkOrder({
                  activityId,
                  activityCode
                });
              }}
              className={cx(styles.btn, styles.teamBtn)}>
              {getJoinGroupBtnText()}
            </Button>
          ) : (
            <Button
              disabled={btnDisabled}
              onClick={() => {
                sensClickInitiative({
                  $element_name: '运营活动活动页_组件点击',
                  $element_id: componentId,
                  $element_type: '拼团',
                  $element_content: '2'
                });

                checkOrder({
                  activityId,
                  activityCode
                });
              }}
              className={cx(styles.btn, styles.teamBtn)}>
              发起团购
            </Button>
          )}
        </div>
      </div>
    );
  }
);

function formatNumber(val: number) {
  if (val > 9) {
    return `${val}`;
  }
  return `0${val}`;
}

const TeamPanelShare = React.memo(
  ({
    fastTeam,
    teamStatus,
    minGroupPrice,
    startDate,
    maxOriginalPrice,
    activityId,
    activityCode,
    componentId,
    // isNoGoods,
    // isCanJoinGroup,
    invite
  }: Omit<
    TeamPanelProps,
    'endDate' | 'isCanJoinGroup' | 'isNoGoods' | 'productId'
  >): JSX.Element => {
    const [tips, setTips] = useState(false);
    const [time, setTime] = useState<number>(Number(fastTeam?.countdown) || 0);
    const timeRef = useRef(0);
    timeRef.current = time;

    const isTeamOpen = useMemo(() => {
      return Boolean(fastTeam?.nickName);
    }, [fastTeam?.nickName]);

    // 没有位置
    const isFull = Number(fastTeam?.lastCount) <= 0;

    useEffect(() => {
      clearInterval(timer2);

      // 拼团倒计时
      if (
        fastTeam &&
        teamStatus === 1 &&
        Number(fastTeam.countdown) > 1000 &&
        Number(fastTeam?.lastCount) > 0
      ) {
        timer2 = setInterval(() => {
          const t = timeRef.current - 1000;
          setTime(t);
        }, 1000);
      }

      // 开团倒计时
      if (teamStatus === 0) {
        timer2 = setInterval(() => {
          const t = startDate - Date.now();
          setTime(t);
        }, 1000);
      }

      return () => {
        clearInterval(timer2);
      };
    }, [fastTeam, startDate, teamStatus]);

    const timeObj = durationTime(time, 'obj');

    const actStatus = useMemo(() => {
      return getActStatus(invite);
    }, [invite]);

    useEffect(() => {
      const { scene } = __store?.sceneParams || {};
      if (scene === 'GROUP') {
        __store.sceneParams = null;
        const isJoin = participateStatus.includes(actStatus);

        // 对于扫码参团，只有当用户登录后是参团才可触发，开团都需用户二次确认
        if (!isJoin || !invite.collageLimitIncludedCurrentUser) {
          bus.emit(PAGE_LOADING_STOP);
          return;
        }
        checkOrder(
          {
            activityId,
            activityCode,
            groupBookingId: fastTeam?.groupBookId
          },
          true
        );
      }
    }, [actStatus]);

    const btnRenderText = btnText[actStatus];
    let msgRenderText = msgText[actStatus];
    msgRenderText = msgRenderText === 'collageLimitText' ? invite.collageLimitText : msgRenderText;

    return (
      <>
        <div className={styles['cp-team-share']}>
          {isTeamOpen ? (
            <div className={styles.item}>
              <div className={styles.avatar}>
                {fastTeam?.groupAvatarUrl?.slice(0, 3)?.map((item: string, index) => {
                  return (
                    <div key={item} className={styles.img}>
                      {index ? null : <i className='ui-icon ui-icon__img13' />}
                      <img src={item || DEFAULT_HEAD_PIC} alt='' />
                    </div>
                  );
                })}
              </div>

              {msgRenderText !== 'time' ? (
                <div className={styles.info}>
                  <div
                    onClick={() => {
                      setTips(true);
                    }}
                    className={styles.t}>
                    <span>{msgRenderText}</span>
                    {isFull ? <i className='ui-icon ui-icon__img17' /> : null}
                  </div>
                </div>
              ) : (
                <div className={styles.info}>
                  <div
                    onClick={() => {
                      setTips(true);
                    }}
                    className={styles.h}>
                    仅剩
                    <span>{fastTeam?.lastCount}</span>
                    位好友，即可拼团成功
                    <i className='ui-icon ui-icon__img17' />
                  </div>

                  <div className={styles.timer}>
                    剩余
                    <span>{formatNumber(Math.floor(timeObj.asDays()))}</span>天
                    <span>{formatNumber(timeObj.hours())}</span>:
                    <span>{formatNumber(timeObj.minutes())}</span>:
                    <span>{formatNumber(timeObj.seconds())}</span>
                    结束
                  </div>
                </div>
              )}
            </div>
          ) : null}
          <div className={styles.buy}>
            <strong>¥{computePrice(minGroupPrice)}</strong>
            <span>
              单买价<s>¥{computePrice(maxOriginalPrice)}</s>
            </span>
            {btnRenderText ? (
              <Button
                onClick={() => {
                  const isJoin = participateStatus.includes(actStatus);

                  // 开团验证
                  if (openStatus.includes(actStatus) && !invite.activityScopeIncludedCurrentUser) {
                    Toast.info('您没有开团权限');
                    return;
                  }

                  // 参团验证
                  if (isJoin && !invite.collageLimitIncludedCurrentUser) {
                    Toast.info('您没有参团权限');
                    return;
                  }

                  sensClickInitiative({
                    $element_name: '运营活动活动页_组件点击',
                    $element_id: componentId,
                    $element_type: '拼团',
                    $element_content: isJoin ? '10' : '2'
                  });

                  checkOrder({
                    activityId,
                    activityCode,
                    groupBookingId: isJoin ? fastTeam?.groupBookId : undefined
                  });
                }}
                disabled={actStatus === 0}
                className={styles.btn}>
                {btnRenderText}
              </Button>
            ) : null}
          </div>
        </div>
        <TipsPopup
          visible={tips}
          title=''
          btnText='我知道啦'
          onConfirm={() => {
            setTips(false);
          }}>
          <img className={styles['t-img']} src={require('@/assets/activity/img15.png')} alt='' />
        </TipsPopup>
      </>
    );
  }
);

export { TeamList, TeamPanel, TeamPanelShare };
